import { Component, Input } from '@angular/core';
import { EmployeeBenefitBulk } from '@models/payroll/employee/benefit-bulk.model';
import { BaseForm } from '@forms/base.form';
import { BenefitDeductionFrequency } from '@models/payroll/company/benefit-deduction-frequency.model';

const { SORT_ORDER } = BenefitDeductionFrequency;

@Component({
    selector: 'app-employee-benefit-bulk-form',
    templateUrl: './employee-benefit-bulk.template.html',
})
export class EmployeeBenefitBulkForm extends BaseForm {
    @Input() benefit: EmployeeBenefitBulk = new EmployeeBenefitBulk();
    @Input() selectionCount = 0;

    dropdownCalculatorOptions = [
        { label: '$', value: 'dollar' },
        { label: '%', value: 'percent' },
    ];

    dropdownFrequencyOptions: { label: string; value: number }[] = [];

    constructor() {
        super();

        this.getBenefitDeductionFrequencies();
    }

    private async getBenefitDeductionFrequencies(): Promise<void> {
        const [results] = await BenefitDeductionFrequency.get();

        const options = results.map((result) => {
            return {
                label: result.displayName,
                name: result.name,
                value: result.id,
            };
        });

        this.dropdownFrequencyOptions = SORT_ORDER.map((order) => options.find(({ name }) => name == order));
    }
}
